import {Typography} from "@mui/material";
import {BREAK_TIMESLOT_TITLE, TRAINING_TIMESLOT_TITLE} from "../../views/MySessionsView";
import {SESSION_TYPE} from "../../domain/SessionType";

export default function UnbookedTimeslotDetails({selectedEvent, compactView = false}) {

    const unbookableLabelStyle = {
        marginTop: compactView ? "1rem" : "0.6rem",
        marginLeft: compactView ? "0.5rem" : "3.8rem",
        marginBottom: "1rem",
        fontWeight: "bold",
        height: compactView ? "8.7rem" : "auto",
    }

    return (
      <Typography sx={unbookableLabelStyle}>
          {
              selectedEvent.sessionType === SESSION_TYPE.TRAINING
                ? TRAINING_TIMESLOT_TITLE
                : BREAK_TIMESLOT_TITLE
          }
      </Typography>
    )
}
